// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".rotate_class[data-v-6d7cdcfa]{-webkit-transition:-webkit-transform .3s ease;transition:-webkit-transform .3s ease;transition:transform .3s ease;transition:transform .3s ease,-webkit-transform .3s ease}.custom-checkbox-label[data-v-6d7cdcfa] .custom-control-label{margin-top:2px!important}", ""]);
// Exports
module.exports = exports;
